import React, { useState, useEffect, Fragment } from 'react';
import { isDesktop } from 'react-device-detect';
import PropTypes from 'prop-types';
import axios from 'axios';
import { EmailShareButton, FacebookShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share'; 

import { googleSheetKey, query, qryParam, socialShareText, title, twitterAccount, urlAssets, urlBrand, urlEspecial, urlCommonAssets2, urlPortadaEspeciales, brand } from '../../Constants';

//components
import LateralIzquierdo from '../../ads/LateralIzquierdo';
import LateralDerecho from '../../ads/LateralDerecho';
import Caja3 from '../../ads/Caja3';
import Zocalo  from '../../ads/Zocalo'; 
import Footer from '../common/Footer';
import Loading from '../common/Loading';
import PostalImg from '../common/PostalImg';
import CardHeader from '../common/CardHeader';
import BrandMail from '../common/BrandMail';

const Card = props => {

    const { idTarjeta, viewCard } = props;
    const urlJson = `https://docs.google.com/spreadsheets/d/${googleSheetKey}/gviz/tq?tq=${query}${idTarjeta}`;

    const [loading, setLoading] = useState(true);
    const [contentCard, setContentCard] = useState({ idPostal: '', name: '', msg: '' });
    const { idPostal, name, msg } = contentCard;

    const getCard = async () => {
        try{
            const result = await axios(urlJson);
            const jsonContent = JSON.parse((result.data).substr(47).slice(0,-2));
            const arrayContentCard = jsonContent.table.rows[0]['c'];

            setContentCard({
                idPostal: (arrayContentCard[0]['v']).toString(), 
                name: arrayContentCard[1]['v'], 
                msg: arrayContentCard[2]['v'] 
            });

            setLoading(false);
        }
        catch(error){
            console.log('Error al obtener el mensaje: ',error);
        }            
    } 
    
    useEffect(() => {
        getCard(); 
    }, []);

    return (
        <Fragment>
            <main className="container cont-principal px-0 cont-layout">
                <section className="d-flex justify-content-around">
                    {isDesktop && <LateralIzquierdo />}
                    <section className="container my-3 my-md-4 px-4 px-md-0">
                        {
                            (loading)
                                ? <Loading height="vh-100" urlCommonAssets2={urlCommonAssets2} /> 
                                : <Fragment>
                                    <section className="row mx-auto px-2 p-md-0 cont-form-postal">
                                        <PostalImg idPostal={idPostal} title={title} urlAssets={urlAssets} />
                                        <section className="col-12 col-md-6 my-1 bg-form border-form">
                                            <CardHeader title={title} urlAssets={urlAssets} urlBrand={urlBrand} />
                                            <div className="form-group mt-3 mb-0 px-3 py-1">
                                                <label htmlFor="name" className="mail-to text-black">Nombre:</label>    
                                                <input                     
                                                    className="form-control bg-form border-0 border-bottom text-black px-0 borde" 
                                                    name="name"
                                                    readOnly
                                                    type="text" 
                                                    value={name}
                                                />
                                            </div>
                                            <div className="form-group pb-0 pt-1 px-3">
                                                <label htmlFor="msg" className="pb-2 mail-to text-black">Texto</label>
                                                <textarea 
                                                    className="form-control bg-form border-0 text-black content-msg p-2"
                                                    id="msg" 
                                                    name="msg"
                                                    rows="8"
                                                    readOnly
                                                    value={`${msg} ${msg}`}
                                                >
                                                </textarea>
                                            </div>
                                            <BrandMail brand={brand} urlBrand={urlBrand} urlPortadaEspeciales={urlPortadaEspeciales} />
                                        </section>
                                    </section>
                                    <section className="d-flex justify-content-center flex-column flex-md-row mt-3 mb-2 mb-md-5 p-0 text-center">
                                        <article className="d-md-flex align-items-md-center text-center my-2 my-md-0">
                                            <span className="mx-1 py-1 text-black share-text">Ahora comparte tu tarjeta por</span>
                                        </article>
                                        <section className="d-flex justify-content-center">
                                            <ul className="align-items-center list-group list-group-horizontal">
                                                <li className="d-block mx-1">
                                                    <EmailShareButton
                                                        body="Revisa la tarjeta que te comparto por estas fiestas"
                                                        subject={socialShareText}
                                                        url={`${urlEspecial}${qryParam}${viewCard}=${idTarjeta}`}
                                                    >
                                                        <ASocialShare icon="email" />
                                                    </EmailShareButton>  
                                                </li> 
                                                <li className="d-block mx-1">
                                                    <TwitterShareButton
                                                        url={`${urlEspecial}${qryParam}${viewCard}=${idTarjeta}`}
                                                        title={socialShareText}
                                                        via={twitterAccount}
                                                    >
                                                        <ASocialShare icon="twitter" />
                                                    </TwitterShareButton>                            
                                                </li>                    
                                                <li className="d-block mx-1">
                                                    <FacebookShareButton
                                                        quote={socialShareText}
                                                        url={`${urlEspecial}${qryParam}${viewCard}=${idTarjeta}`}
                                                    >
                                                        <ASocialShare icon="facebook" />
                                                    </FacebookShareButton>
                                                </li>   
                                                <li className="d-block mx-1">
                                                    <WhatsappShareButton
                                                        url={`${urlEspecial}${qryParam}${viewCard}=${idTarjeta}`}
                                                        title={socialShareText}
                                                        windowWidth="600"
                                                        windowHeight="600"
                                                    >
                                                        <ASocialShare icon="whatsapp" />
                                                    </WhatsappShareButton>  
                                                </li>          
                                            </ul>
                                        </section>
                                    </section>
                                </Fragment>
                        }
                    </section>
                    {isDesktop && <LateralDerecho />}    
                </section>                                        
                <section className="content-msgs">
                    {!isDesktop && <Caja3 />}        
                    <Zocalo isDesktop={isDesktop} />
                </section> 
            </main>
            <Footer />
        </Fragment>
    )
}

export default Card;

Card.propTypes = {
    idTarjeta: PropTypes.string.isRequired,
    viewCard: PropTypes.string.isRequired
}

const ASocialShare = props => {

    const { icon } = props;

    return (
        <a href="/#">
            <img className="img-fluid" src={`${urlCommonAssets2}img/${icon}-card.png`} alt={icon} />
        </a>   
    )
}